import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"linkedin\">\r\n  <path id=\"linkedin_linkedin\" d=\"M42.6,42.608h-7.4v-11.6c0-2.767-.056-6.327-3.858-6.327-3.86,0-4.45,3.01-4.45,6.123V42.608h-7.4V18.75h7.112V22h.1a7.8,7.8,0,0,1,7.021-3.854c7.5,0,8.89,4.938,8.89,11.365v13.1ZM11.119,15.485a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,11.119,15.485Zm3.713,27.123H7.406V18.75h7.425ZM46.3,0H3.69A3.645,3.645,0,0,0,0,3.6V46.4A3.644,3.644,0,0,0,3.69,50H46.3A3.658,3.658,0,0,0,50,46.4V3.6A3.659,3.659,0,0,0,46.3,0Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol